import { render, staticRenderFns } from "./FullPageImgPop.vue?vue&type=template&id=d5c0d066&scoped=true&"
import script from "./FullPageImgPop.vue?vue&type=script&lang=js&"
export * from "./FullPageImgPop.vue?vue&type=script&lang=js&"
import style0 from "./FullPageImgPop.vue?vue&type=style&index=0&id=d5c0d066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c0d066",
  null
  
)

export default component.exports